<div class="col-md-12">
  <div class="row mb-3">
    <div class="col-md-8">
      <span class="badge badge-primary">{{ transactions?.length || 0 }} transaction(s)</span>
    </div>
    <div class="col-md-4 text-right">
      <button class="btn btn-primary btn-sm" (click)="addTransaction()">
        <i class="feather icon-plus"></i> Ajouter
      </button>
    </div>
  </div>
  <div class="table-responsive">
    <table datatable [dtOptions]="dtOptions" class="table table-sm table-striped table-bordered nowrap table-hover">
      <thead class="thead-light">
        <tr>
          <th>Code</th>
          <th>Date</th>
          <th>Libellé</th>
          <th>Type</th>
          <th>Catégorie</th>
          <th>Mode paiement</th>
          <th>Montant</th>
          <th>Compte</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of transactions">
          <td>{{ item?.code }}</td>
          <td>{{ item?.date }}</td>
          <td>{{ item?.libelle }}</td>
          <td>
            <span class="badge" [ngClass]="item?.type === 'ENCAISSEMENT' ? 'badge-success' : 'badge-danger'">
              {{ item?.type }}
            </span>
          </td>
          <td>{{ item?.categorie }}</td>
          <td>{{ item?.modePaiement }}</td>
          <td class="text-right" [ngClass]="item?.type === 'ENCAISSEMENT' ? 'text-success' : 'text-danger'">
            {{ item?.type === 'ENCAISSEMENT' ? '+' : '-' }}{{ item?.montant | number:'1.0-0' }} FCFA
          </td>
          <td>{{ item?.compte?.libelle }}</td>
          <td class="text-center">
            <button class="btn btn-icon btn-outline-primary btn-sm mr-1" title="Modifier" (click)="editTransaction(item)">
              <i class="feather icon-edit-2"></i>
            </button>
            <button class="btn btn-icon btn-outline-danger btn-sm" title="Supprimer" (click)="deleteTransaction(item)">
              <i class="feather icon-trash"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
